import { USER_EVENTS } from '@shared/core/user-events'

export const ALERT_CAMPAIGN_IDS = {
  AUTO_REMINDERS: 'auto-reminders',
  FEEDBACK_SURVEY: 'feedback-survey',
  G2_CAPTERRA_REVIEW: 'g2-capterra-review',
  INSTALL_CHROME_EXTENSION: 'install-chrome-extension',
  KALAMA_TEASER: 'kalama-teaser',
  KALAMA_RENAMED: 'kalama-renamed',
  PAUSED_REMINDERS: 'paused-reminders',
  SUBSCRIPTION_ENDED_REMINDERS: 'subscription-ended-reminders',
  TYPEFORM_REVIEW: 'typeform-review',
  SET_AND_FORGET_PROMO: 'set-and-forget-promo',
  SHOPIFY_WORDPRESS_SURVEY: 'shopify-wordpress-survey',
} as const

export const ALERT_CAMPAIGN_PRIORITIES = {
  PAUSED_REMINDERS: 5,
  SUBSCRIPTION_ENDED_REMINDERS: 5,
  KALAMA_TEASER: 7,
  KALAMA_RENAMED: 7,
  INSTALL_CHROME_EXTENSION: 10,
  AUTO_REMINDERS: 15,
  SET_AND_FORGET_PROMO: 16,
  TYPEFORM_REVIEW: 18,
  SHOPIFY_WORDPRESS_SURVEY: 19,
  FEEDBACK_SURVEY: 20,
  G2_CAPTERRA_REVIEW: 25,
} as const

export const ALERT_CAMPAIGN_SEEN_EVENTS = {
  [ALERT_CAMPAIGN_IDS.AUTO_REMINDERS]: USER_EVENTS.AUTO_REMINDERS_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.INSTALL_CHROME_EXTENSION]: USER_EVENTS.INSTALL_CHROME_EXTENSION_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.PAUSED_REMINDERS]: USER_EVENTS.PAUSED_REMINDERS_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.SUBSCRIPTION_ENDED_REMINDERS]: USER_EVENTS.SUBSCRIPTION_ENDED_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.KALAMA_TEASER]: USER_EVENTS.KALAMA_TEASER_WEB_POPUP_SEEN,
  [ALERT_CAMPAIGN_IDS.KALAMA_RENAMED]: USER_EVENTS.KALAMA_RENAMED_WEB_POPUP_SEEN,
  [ALERT_CAMPAIGN_IDS.FEEDBACK_SURVEY]: USER_EVENTS.FEEDBACK_SURVEY_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.G2_CAPTERRA_REVIEW]: USER_EVENTS.G2_CAPTERRA_REVIEW_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.TYPEFORM_REVIEW]: USER_EVENTS.REVIEW_FIRST_EVENT_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.SET_AND_FORGET_PROMO]: USER_EVENTS.SET_AND_FORGET_PROMO_MODAL_SEEN,
  [ALERT_CAMPAIGN_IDS.SHOPIFY_WORDPRESS_SURVEY]: USER_EVENTS.SHOPIFY_WORDPRESS_SURVEY_MODAL_SEEN,
} as const

export const SURVEY_MODAL_LAUNCH_DATE = new Date('2026-04-08T00:00:00.000Z')

export const ALERTS_COOLDOWN_MS = 60_000

export const PAUSED_REMINDERS_MODAL_ROW_LIMIT = 3
